// extracted by mini-css-extract-plugin
module.exports = {"entitiesSettings":"_5gzEp","addEntitiesButton":"_2O6Gf","newEntityFormItem":"_2BYDb","addEntitiesPopover":"_3piaA","openedNewEntityButton":"_1FPS9","newEntityInput":"AWIHx"};